export enum KeywordRankType {
  /** 热搜榜  */
  WELL = 1,
  /** 飙升榜 */
  INCR = 2,
}

export const keywordRankTypeLabel = {
  [KeywordRankType.WELL]: "热搜榜",
  [KeywordRankType.INCR]: "飙升榜",
};
